<app-header [filled]="true"></app-header>
<ion-content [lang]="languageService.lang()" scroll-events="true" fullscreen="true"
             [dir]="languageService.dir()">
<!--             scroll-events="true" (ionScroll)="onScroll($event)">-->

  <div class="content-wrapper">
    <h1>{{ 'about.title' | translate }} <small>
      <a href="https://g.co/kgs/Qj1wrAD" target="_blank"><ion-icon name="location-outline"></ion-icon> {{ 'about.location' | translate }}</a>
    </small></h1>

    <section class="inner-banner" (mouseleave)="isActive = 1">
      <div class="section-1" [style]="'background-image: url(' + pageImages()?.banner1 + ')'"
           [ngClass]="{'_active': isActive === 1}" (mouseenter)="setActive(1)" (mouseleave)="resetActive()"></div>
      <div class="section-2" [style]="'background-image: url(' + pageImages()?.banner2 + ')'"
           [ngClass]="{'_active': isActive === 2}" (mouseenter)="setActive(2)" (mouseleave)="resetActive()"></div>
      <div class="section-3" [style]="'background-image: url(' + pageImages()?.banner3 + ')'"
           [ngClass]="{'_active': isActive === 3}" (mouseenter)="setActive(3)" (mouseleave)="resetActive()"></div>
    </section>

  </div>

  <app-column-content [title]="pageContent()?.[languageService.lang()].section1Title"
                      [content]="pageContent()?.[languageService.lang()].section1Description"></app-column-content>

  <div class="shade-bg">
    <article class="article">
      <h2 class="h2">{{ 'about.fast_facts.title' | translate }} <span>{{ 'about.fast_facts.last_update' | translate }} {{updateDate() | date}}</span></h2>

      <div class="facts-wrapper">
        @for (x of pageContent()?.fastFacts; track x; let i = $index) {
          <div class="card">
              <span class="icon">
                <ion-img [src]="pageImages()['fact' + (i + 1)]" alt="About Satel fact"></ion-img>
              </span>
            <span class="number">{{ x?.[languageService.lang()].title }}</span>
            <span class="text">{{ x?.[languageService.lang()].text }}</span>
          </div>
        }
      </div>

    </article>
  </div>

  <div class="fullpage-slider">
    <div id="sectionX">
      @for (slide of pageContent()?.fullScreenSlider; track slide; let i = $index) {
        <div class="section slide" [style]="'background-image: url(' + pageImages()?.['slider' + (i + 1)] + ')'">
          <div class="overlay">
            <div class="content-wrapper">
              <h3>{{ slide?.[languageService.lang()].title }}</h3>
              <p>{{ slide?.[languageService.lang()].text }}</p>
            </div>
          </div>
          <!--        <ion-img src="./assets/inner/about/slide1.png" alt="Satel Realty Riyadh"></ion-img>-->
        </div>
      }
    </div>
  </div>

  <app-content-swiper-slider page="about" [title]="pageContent()?.[languageService.lang()].bottomSliderTitle" [items]="pageContent()?.bottomSlider"></app-content-swiper-slider>

  <app-b2b-section></app-b2b-section>
  <app-footer></app-footer>
</ion-content>
